import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchMerchantInfo } from '@api/merchant-info/merchant-info.api';
import { ApiError } from '@lib/request';
import { ApiErrorType } from '@typings/common';
import { FetchMerchantInfoParamsDto, MerchantInfoType } from '@api/merchant-info/merchant-info.dto';

export const fetchMerchantInfoAction = createAsyncThunk<
    MerchantInfoType,
    FetchMerchantInfoParamsDto,
    { rejectValue: ApiErrorType<unknown> }
>(`FETCH_MERCHANT_INFO`, async (payload, thunkApi) => {
    try {
        const result = await fetchMerchantInfo(payload);
        return result;
    } catch (error) {
        if (error instanceof ApiError) {
            return thunkApi.rejectWithValue(error.toJSON());
        }
        if (error instanceof Error) {
            throw new ApiError(error.message);
        }
        throw new ApiError();
    }
});
